import { render, staticRenderFns } from "./alert-bar.vue?vue&type=template&id=58a7384d&scoped=true"
import script from "./alert-bar.vue?vue&type=script&lang=js"
export * from "./alert-bar.vue?vue&type=script&lang=js"
import style0 from "./alert-bar.vue?vue&type=style&index=0&id=58a7384d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a7384d",
  null
  
)

export default component.exports